import React, { useEffect, useState } from "react";
import { Breadcrumb } from "@gull";
import { SimpleCard } from "@gull";
import moment from "moment";
import swal from "sweetalert2";
import MySalary from "../EmployeeProfile/MySalary";

const CalculationList = () => {
  return (
    <div>
      <Breadcrumb routeSegments={[{ name: "Salary Calculation Table" }]} />

      <SimpleCard>
      <MySalary fromCalculationList={true} />
            </SimpleCard>
    </div>
  );
};

export default CalculationList;
